<template>
  <div class="state8">
    <lib :is-classic="true"></lib>
  </div>
</template>

<script>
import lib from "../../questionlib/index.vue";

export default {
  name: "ClassicQuestionsIndex",
  components: { lib }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";
</style>
